export const typeOptions = [
  { label: 'Новость', value: 'news' },
  { label: 'Статья', value: 'article' },
  { label: 'Энциклопедия', value: 'encyclopedia' },
  { label: 'Wiki - FAQ', value: 'faq' },
  { label: 'Гарри Поттер Вики', value: 'harry-potter-wiki' },
  { label: 'Обзор', value: 'review' },
  { label: 'Лонгрид', value: 'longread' },
  { label: 'Интервью', value: 'interview' },
  { label: 'Подборка', value: 'collection' },
  { label: 'Топ', value: 'top' },
  { label: 'Опрос', value: 'poll' },
  { label: 'Конкурс', value: 'contest' },
  { label: 'Блог разработчика', value: 'dev-blog' },
  { label: 'Мероприятия', value: 'events' },
  { label: 'Квиз', value: 'quiz' },
];
